import { MarkedMenuItem } from '../model/menu-item';

export const useMenuItems = <K extends string>(display: Record<K, boolean>, items: Array<MarkedMenuItem<K>>) => {
    return {
        menuItems: items.filter(({ tab }) => display[tab]),
        display,
    };
};
